var _defs, _sodipodiNamedview, _path, _path2, _path3, _path4, _path5, _path6, _line, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPisos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 450 368.14368",
    fill: "none",
    id: "svg308",
    sodipodiDocname: "pisos2.svg",
    inkscapeVersion: "1.1.2 (b8e25be833, 2022-02-05)",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs312"
  })), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview310",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    inkscapePageshadow: 2,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    showgrid: "false",
    "fit-margin-top": 0,
    "fit-margin-left": 0,
    "fit-margin-right": 0,
    "fit-margin-bottom": 0,
    inkscapeZoom: 1.3213429,
    inkscapeCx: 429.4873,
    inkscapeCy: 214.17604,
    "inkscapeWindow-width": 1680,
    "inkscapeWindow-height": 987,
    "inkscapeWindow-x": -8,
    "inkscapeWindow-y": -8,
    "inkscapeWindow-maximized": 1,
    "inkscapeCurrent-layer": "svg308"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 345.49905,65.919038 h -54.971 l -24.284,61.797002 h 54.971 z",
    fill: "#f7efe4",
    id: "path8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m 351.09505,65.919038 -24.285,61.797002 h 54.972 l 24.284,-61.797002 z",
    fill: "#f7efe4",
    id: "path10"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m 319.30905,132.56704 h -54.972 l -34.983,89.024 h 54.97 z",
    fill: "#f7efe4",
    id: "path12"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m 289.92105,221.59104 h 54.97 l 34.985,-89.025 h -54.972 z",
    fill: "#f7efe4",
    id: "path14"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m 227.31805,226.77104 -34.984,89.024 h 54.972 l 34.983,-89.024 z",
    fill: "#f7efe4",
    id: "path16"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m 252.90105,315.79504 h 54.972 l 34.983,-89.024 h -54.97 z",
    fill: "#f7efe4",
    id: "path18"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 366.12863,
    x2: 450,
    y2: 366.12863,
    stroke: "#000000",
    strokeWidth: 4.03008,
    id: "line38"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m 214.36305,57.034638 c -3.723,0 -6.752,3.0317 -6.752,6.7581 0,3.7264 3.029,6.7581 6.752,6.7581 3.723,0 6.752,-3.0317 6.752,-6.7581 0,-3.7264 -3.029,-6.7581 -6.752,-6.7581 z m 0,14.1627 c -4.08,0 -7.398,-3.3213 -7.398,-7.4046 0,-4.0824 3.318,-7.4046 7.398,-7.4046 4.078,0 7.397,3.3222 7.397,7.4046 0,4.0833 -3.319,7.4046 -7.397,7.4046 z",
    fill: "#ffffff",
    id: "path68"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m 214.36305,63.792638 c -1.745,0 -3.172,-1.4283 -3.172,-3.1747 v -9.5182 c 0,-1.7456 1.427,-3.1748 3.172,-3.1748 1.744,0 3.172,1.4292 3.172,3.1748 v 9.5182 c 0,1.7464 -1.428,3.1747 -3.172,3.1747 z",
    fill: "#343a55",
    id: "path70"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m 272.86705,66.008738 c -17.308,-6.6495 -37.259,-10.4449 -58.504,-10.4449 -21.245,0 -41.196,3.7954 -58.505,10.4449 z",
    fill: "#1f33ac",
    id: "path72"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m 214.68605,47.924638 h -0.646 V 0 h 0.646 z",
    fill: "#2c3451",
    id: "path74"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m 329.07705,188.70104 c 0,0 10.265,-7.577 5.629,-11.624 -10.891,-9.077 -39.033,21.975 -38.303,25.222 0.728,3.246 34.894,9.469 40.739,-6.191 3.78,-9.606 -8.065,-7.407 -8.065,-7.407 z",
    fill: "#618e77",
    id: "path76"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m 329.07705,188.70104 c 0,0 -8.585,0.675 -32.674,13.598 0.728,3.246 34.894,9.469 40.739,-6.191 3.78,-9.606 -8.065,-7.407 -8.065,-7.407 z",
    fill: "#75aa8d",
    id: "path78"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m 307.58505,196.92004 -0.283,-0.582 c 25.736,-12.522 42.047,-12.705 48.481,-0.545 l -0.571,0.303 c -6.239,-11.793 -22.264,-11.517 -47.627,0.824 z",
    fill: "#35685e",
    id: "path80"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m 297.76205,202.04604 -0.313,-0.565 c 2.037,-1.129 4.041,-2.202 5.955,-3.189 l 0.297,0.575 c -1.91,0.984 -3.907,2.054 -5.939,3.179 z",
    fill: "#35685e",
    id: "path82"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m 368.66305,194.26104 h -8.841 -8.84 c 0,0 -12.081,50.241 -11.001,57.418 1.081,7.178 5.501,11.012 5.501,11.012 h 14.34 14.342 c 0,0 4.421,-3.834 5.5,-11.012 1.081,-7.177 -11.001,-57.418 -11.001,-57.418 z",
    fill: "#d19e66",
    id: "path84"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m 369.24605,196.95204 h -18.846 v -0.646 h 18.846 z",
    fill: "#2c3451",
    id: "path86"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m 379.66405,251.40404 h -39.736 v -0.646 h 39.736 z",
    fill: "#2c3451",
    id: "path88"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m 383.25905,270.14004 h -46.872 v -7.449 h 46.872 z",
    fill: "#343a55",
    id: "path90"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m 337.17505,367.19704 -0.645,-0.032 4.983,-98.959 0.645,0.031 z",
    fill: "#2c3451",
    id: "path92"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m 382.47005,367.19704 -4.982,-98.96 0.646,-0.031 4.982,98.959 z",
    fill: "#2c3451",
    id: "path94"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m 381.78805,347.54504 h -43.93 v -0.646 h 43.93 z",
    fill: "#2c3451",
    id: "path96"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m 381.06505,333.19104 h -42.484 v -0.647 h 42.484 z",
    fill: "#2c3451",
    id: "path98"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m 393.09005,198.91204 c 0,0 -10.177,-7.695 -12.734,-2.094 -5.596,13.033 24.537,36.479 27.438,34.856 2.902,-1.622 6.756,-41.454 -9.905,-42.607 -10.275,-0.896 -4.799,9.845 -4.799,9.845 z",
    fill: "#618e77",
    id: "path100"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m 393.09005,198.91204 c 0,0 -10.177,-7.695 -12.734,-2.094 -5.596,13.033 24.537,36.479 27.438,34.856 -0.833,-7.653 -9.517,-29.613 -14.704,-32.762 z",
    fill: "#75aa8d",
    id: "path102"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m 353.61005,165.43404 c 0,0 0.491,10.225 -7.661,9.242 -8.153,-0.983 -1.67,-30.31 -1.67,-30.31 0,0 26.324,15.366 19.252,22.051 -5.021,5.396 -9.921,-0.983 -9.921,-0.983 z",
    fill: "#75aa8d",
    id: "path104"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m 353.61005,165.43404 -9.331,-21.068 c 0,0 26.324,15.366 19.252,22.051 -5.021,5.395 -9.921,-0.983 -9.921,-0.983 z",
    fill: "#618e77",
    id: "path106"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m 371.41605,174.38804 c 7.206,-9.386 19.784,-15.02 34.385,-19.873 0,0 -6.826,22.908 -15.765,26.104 -8.742,2.507 -18.62,-6.231 -18.62,-6.231 z",
    fill: "#618e77",
    id: "path108"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m 340.41605,165.64704 c 0,0 -12.81,-14.379 -22.203,-21.281 0,0 1.795,16.936 7.494,21.323 5.717,3.844 14.709,-0.042 14.709,-0.042 z",
    fill: "#618e77",
    id: "path110"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m 367.26205,180.03004 -0.551,-0.337 c 7.856,-12.874 23.377,-19.855 38.981,-25.482 l 0.219,0.608 c -15.492,5.587 -30.898,12.508 -38.649,25.211 z",
    fill: "#35685e",
    id: "path112"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m 362.33805,194.30204 -0.641,-0.083 c 0.533,-4.171 1.693,-8.097 3.447,-11.672 l 0.58,0.285 c -1.723,3.51 -2.862,7.369 -3.386,11.47 z",
    fill: "#35685e",
    id: "path114"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m 359.50005,194.28604 c -1.532,-19.288 -8.752,-36.522 -14.538,-47.583 l 0.572,-0.299 c 5.815,11.114 13.069,28.434 14.611,47.831 z",
    fill: "#35685e",
    id: "path116"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m 403.53205,217.95504 c -5.814,-16.723 -16.24,-28.274 -26.563,-29.426 -4.989,-0.557 -9.241,1.538 -11.957,5.903 l -0.549,-0.343 c 2.856,-4.586 7.318,-6.792 12.579,-6.203 10.567,1.18 21.204,12.9 27.101,29.857 z",
    fill: "#35685e",
    id: "path120"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m 345.12505,205.89204 c 0,0 2.158,-8.467 -3.374,-7.179 -12.674,3.255 -6.364,34.923 -3.542,36.13 2.822,1.208 27.645,-14.832 19.091,-27.673 -5.141,-8.023 -12.175,-1.278 -12.175,-1.278 z",
    fill: "#618e77",
    id: "path122"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m 345.12505,205.89204 c 0,0 -5.601,17.867 -6.916,28.951 2.822,1.208 27.645,-14.832 19.091,-27.673 -5.141,-8.023 -12.175,-1.278 -12.175,-1.278 z",
    fill: "#75aa8d",
    id: "path124"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m 357.13005,194.38304 c -5.277,-12.892 -12.916,-24.695 -22.702,-35.079 l 0.47,-0.443 c 9.841,10.442 17.522,22.311 22.83,35.277 z",
    fill: "#35685e",
    id: "path126"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m 331.24405,156.04804 c -4.036,-3.981 -8.486,-7.825 -13.226,-11.424 l 0.39,-0.515 c 4.762,3.616 9.233,7.478 13.289,11.479 z",
    fill: "#35685e",
    id: "path128"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m 339.04205,231.38704 -0.635,-0.113 c 0.287,-1.619 7.155,-39.674 16.915,-42.154 1.618,-0.215 2.944,0.109 3.979,0.945 1.842,1.489 2.077,4.06 2.087,4.168 l -0.643,0.055 c -0.003,-0.024 -0.226,-2.411 -1.853,-3.723 -0.891,-0.718 -2.052,-0.992 -3.45,-0.811 -9.321,2.371 -16.33,41.241 -16.4,41.633 z",
    fill: "#35685e",
    id: "path130"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m 235.39405,307.50304 h -14.995 v -29.441 h 14.995 z",
    fill: "#ffffff",
    id: "path166"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m 255.05105,307.50304 h -14.995 v -36.339 h 14.995 z",
    fill: "#ffffff",
    id: "path168"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m 245.42705,307.50304 h -14.995 v -22.114 h 14.995 z",
    fill: "#f7efe4",
    id: "path170"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m 228.22005,278.06204 h -0.646 v -1.832 h 0.646 z",
    fill: "#2c3451",
    id: "path172"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "m 247.87705,271.16404 h -0.646 v -1.832 h 0.646 z",
    fill: "#2c3451",
    id: "path174"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m 238.25205,285.38904 h -0.646 v -1.832 h 0.646 z",
    fill: "#2c3451",
    id: "path176"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "m 262.82805,309.59804 h -48.466 v -2.095 h 48.466 z",
    fill: "#829cbf",
    id: "path178"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "m 285.72405,305.84804 v -4.299 c 0,-2.062 1.685,-3.75 3.746,-3.75 h -14.67 c -2.059,0 -3.745,1.688 -3.745,3.75 v 4.299 c 0,2.062 1.686,3.75 3.745,3.75 h 14.67 c -2.061,0 -3.746,-1.688 -3.746,-3.75 z",
    fill: "#758fb3",
    id: "path180"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "m 289.46905,297.79904 c -2.06,0 -3.746,1.688 -3.746,3.75 v 4.299 c 0,2.061 1.686,3.75 3.746,3.75 h 27.845 v -11.799 z",
    fill: "#829cbf",
    id: "path182"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "m 289.75305,298.90504 c -1.673,0 -3.044,1.372 -3.044,3.046 v 3.494 c 0,1.675 1.371,3.046 3.044,3.046 h 27.561 v -9.586 z",
    fill: "#ffffff",
    id: "path184"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "m 315.91905,300.68404 h -22.835 v -0.647 h 22.835 z",
    fill: "#758fb3",
    id: "path186"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "m 317.31405,304.58104 h -20.292 v -0.647 h 20.292 z",
    fill: "#758fb3",
    id: "path188"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "m 294.21105,304.58104 h -3.253 v -0.647 h 3.253 z",
    fill: "#758fb3",
    id: "path190"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "m 309.48505,306.96204 h -16.977 v -0.647 h 16.977 z",
    fill: "#758fb3",
    id: "path192"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "m 297.26105,366.85804 h 1.578 l -7.74,-53.329 h -4.192 z m 2.324,0.646 h -2.856 l -10.606,-54.621 h 5.534 z",
    fill: "#2c3451",
    id: "path194"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "m 225.82205,366.85804 h 1.577 l 10.354,-53.329 h -4.191 z m 2.109,0.646 h -2.856 l 7.928,-54.621 h 5.534 z",
    fill: "#2c3451",
    id: "path196"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "m 261.58905,366.85804 h 1.542 l 1.263,-53.329 h -4.127 z m 2.172,0.646 h -2.801 l -1.355,-54.621 h 5.45 l -0.007,0.331 z",
    fill: "#ffffff",
    id: "path198"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "m 322.13805,314.93004 h -119.616 v -5.332 h 119.616 z",
    fill: "#343a55",
    id: "path200"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "m 163.69405,366.85804 h 5.864 l -3.164,-25.873 h -8.503 z m 6.595,0.646 h -7.113 l -6.092,-27.165 h 9.881 z",
    fill: "#2c3451",
    id: "path202"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "m 77.980046,366.85804 h 5.865 l 5.802,-25.873 h -8.502 z m 6.382,0.646 h -7.112 l 3.323,-27.165 h 9.881 z",
    fill: "#2c3451",
    id: "path204"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "m 143.99505,366.85804 h 5.865 l -3.165,-25.873 h -8.502 z m 6.594,0.646 h -7.111 l -6.092,-27.165 h 9.881 z",
    fill: "#ffffff",
    id: "path206"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "m 97.678046,366.85804 h 5.865004 l 5.803,-25.873 h -8.503 z m 6.383004,0.646 h -7.113004 l 3.323004,-27.165 h 9.882 z",
    fill: "#ffffff",
    id: "path208"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "m 98.890046,298.55704 h 49.576004 l 7.86,-0.649 13.985,3.897 4.614,8.226 3.461,17.029 -4.47,8.659 -65.401,2.165 -40.804004,-7.216 1.442,-16.019 9.317,-13.422 11.157,-5.485 z",
    fill: "#1a84ee",
    id: "path210"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "m 174.92705,310.04004 -0.002,-0.01 -4.613,-8.226 -13.987,-3.896 -7.859,0.649 H 98.891046 l -9.264,-2.814 -11.156,5.484 -6.118,8.813 z",
    fill: "#91aece",
    id: "path212"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "m 49.635146,286.52504 20.5909,-7.83 c 2.105,-0.695 3.289,-2.038 3.919,-4.304 l 7.443,-29.9 c 0.881,-3.485 3.016,-5.343 6.489,-5.466 h 11.3 l -5.786,32.147 -20.005,17.752 h -7.875 -9.3002 z",
    fill: "#829cbf",
    id: "path214"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "m 197.93505,286.52504 -20.591,-7.83 c -2.105,-0.695 -3.288,-2.038 -3.919,-4.304 l -7.444,-29.9 c -0.88,-3.485 -3.015,-5.343 -6.488,-5.466 h -11.3 l 5.785,32.147 20.006,17.752 h 7.876 9.3 z",
    fill: "#829cbf",
    id: "path216"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "m 79.480046,327.94404 v -16.939 c 0.027,-2.409 1.001,-4.573 3.203,-5.67 l 16.208,-2.444 c 2.919004,-12.773 -6.253,-24.309 -16.978,-23.384 l -20.177,7.104 -5.3434,15.554 3.6049,12.051 8.9395,11.906 8.979,3.279 z",
    fill: "#829cbf",
    id: "path218"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "m 167.87705,327.94404 v -16.939 c -0.027,-2.409 -1,-4.573 -3.203,-5.67 l -16.208,-2.443 c -2.92,-12.774 6.253,-24.31 16.978,-23.385 l 20.176,7.104 2.696,8.049 -2.685,13.747 c 0,0 -3.569,14.829 -3.569,15.261 0,0.434 -2.487,10.284 -2.487,10.284 h -9.341 z",
    fill: "#829cbf",
    id: "path220"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "m 156.51105,244.89304 c -1.129,-3.778 -3.787,-5.869 -7.961,-5.869 H 98.989046 c -4.174,0 -6.833,2.091 -7.962,5.869 l -8.879,37.561 16.743,20.437 h 49.575004 l 16.925,-20.437 z",
    fill: "#1a84ee",
    id: "path222"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "m 196.82305,286.32604 h -8.905 c -1.747,0 -2.893,0.08 -3.773,2.37 l -11.815,35.838 c -1.406,2.463 -3.298,3.816 -6.921,3.897 h 1.18 -84.460004 c -3.623,-0.081 -5.515,-1.434 -6.921,-3.897 l -11.815,-35.838 c -0.88,-2.29 -2.027,-2.37 -3.773,-2.37 h -8.9046 c -1.8558,0 -2.6489,1.425 -2.1236,2.953 l 14.6132,50.517 c 1.054,2.598 3.92,4.98 7.894,4.98 h 95.490004 9.85 c 3.974,0 6.839,-2.382 7.894,-4.98 l 14.613,-50.517 c 0.526,-1.528 -0.267,-2.953 -2.123,-2.953 z",
    fill: "#1f33ac",
    id: "path224"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M 163.67905,310.36304 H 83.210046 v -0.646 h 80.469004 z",
    fill: "#2c3451",
    id: "path226"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "m 61.849046,286.91404 -0.225,-0.606 15.056,-5.614 0.224,0.606 z",
    fill: "#2c3451",
    id: "path228"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "m 185.17705,286.91404 -15.055,-5.614 0.225,-0.606 15.056,5.614 z",
    fill: "#2c3451",
    id: "path230"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "m 189.38005,169.27304 h -45.001 v -8.367 h 45.001 z",
    fill: "#758fb3",
    id: "path244"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "m 192.52205,173.42504 h -49.68 v -4.153 h 49.68 z",
    fill: "#343a55",
    id: "path246"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "m 150.05705,169.27304 h -0.645 v -8.367 h 0.645 z",
    fill: "#ffffff",
    id: "path248"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "m 152.70305,169.27304 h -0.646 v -8.367 h 0.646 z",
    fill: "#ffffff",
    id: "path250"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "m 181.70005,169.27304 h -0.645 v -8.367 h 0.645 z",
    fill: "#ffffff",
    id: "path252"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "m 184.34605,169.27304 h -0.646 v -8.367 h 0.646 z",
    fill: "#ffffff",
    id: "path254"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "m 93.606046,168.31104 c 2.289,2.424 5.295,4.164 8.684004,4.864 h 6.742 c 3.389,-0.7 6.394,-2.44 8.685,-4.864 z",
    fill: "#d19e66",
    id: "path256"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "m 96.843046,143.21204 c -4.671,3.02 -7.458,8.131 -7.458,13.691 0,7.693 5.455,14.403 12.970004,15.954 l 6.677,-0.006 c 7.451,-1.545 12.905,-8.255 12.905,-15.948 0,-5.56 -2.786,-10.671 -7.458,-13.691 z m 5.447004,30.285 c -7.879004,-1.62 -13.551004,-8.596 -13.551004,-16.594 0,-5.814 2.93,-11.155 7.836,-14.287 l 0.08,-0.051 h 18.012004 l 0.08,0.051 c 4.906,3.132 7.836,8.473 7.836,14.287 0,7.998 -5.672,14.974 -13.486,16.587 z",
    fill: "#ffffff",
    id: "path258"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "m 91.483046,157.04504 h -0.646 c 0,-3.341 1.084,-6.496 3.136,-9.122 l 0.509,0.397 c -1.962,2.513 -2.999,5.53 -2.999,8.725 z",
    fill: "#ffffff",
    id: "path260"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "m 95.964046,146.69704 -0.442,-0.471 c 0.672,-0.63 1.405,-1.201 2.18,-1.696 l 0.347,0.546 c -0.741,0.472 -1.443,1.018 -2.085,1.621 z",
    fill: "#ffffff",
    id: "path262"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "m 101.63805,168.31104 c -4.500004,-1.6 -7.187004,-4.553 -9.950004,-8.741 3.993,0.676 7.59,2.059 10.322004,4.995 -2.584004,-3.495 -3.986004,-8.411 -4.894004,-13.915 3.823004,3.777 6.857004,7.846 8.141004,12.566 -0.216,-5.682 1.359,-11.409 3.755,-17.158 1.055,6.352 1.255,12.295 -0.17,17.458 1.451,-3.621 4.306,-6.567 8.093,-9.067 -1.451,4.137 -3.099,7.574 -5.129,9.666 1.701,-2.008 4.201,-3.284 7.018,-4.27 -2.509,4.055 -5.863,7.034 -9.374,8.466 z",
    fill: "#618e77",
    id: "path264"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "m 103.22905,168.36404 c -0.331,-1.984 -1.47,-3.594 -1.482,-3.611 l 0.525,-0.376 c 0.051,0.07 1.237,1.744 1.595,3.88 z",
    fill: "#35685e",
    id: "path266"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "m 105.87205,168.41104 c -0.499,-1.533 -0.919,-5.01 -0.936,-5.156 l 0.641,-0.078 c 0.005,0.036 0.43,3.562 0.909,5.034 z",
    fill: "#35685e",
    id: "path268"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "m 107.45105,168.46504 -0.567,-0.308 c 0.901,-1.666 1.437,-3.198 1.639,-4.685 l 0.639,0.087 c -0.211,1.566 -0.771,3.17 -1.711,4.906 z",
    fill: "#35685e",
    id: "path270"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "m 108.60605,168.47904 -0.552,-0.336 c 1.054,-1.736 3.421,-4.153 3.521,-4.255 l 0.461,0.454 c -0.024,0.024 -2.415,2.465 -3.43,4.137 z",
    fill: "#35685e",
    id: "path272"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "m 81.109046,190.47204 h 3.773 v -14.929 h -3.773 z m 4.419,0.646 h -5.065 v -16.222 h 5.065 z",
    fill: "#ffffff",
    id: "path274"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "m 210.95305,190.47204 h 3.773 v -14.929 h -3.773 z m 4.419,0.646 h -5.065 v -16.222 h 5.065 z",
    fill: "#ffffff",
    id: "path276"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M 222.32105,177.01304 H 73.514046 v -3.587 H 222.32105 Z",
    fill: "#ffffff",
    id: "path278"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "m 81.109046,138.66404 h 3.773 v -14.929 h -3.773 z m 4.419,0.646 h -5.065 v -16.222 h 5.065 z",
    fill: "#ffffff",
    id: "path280"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "m 210.95305,138.66404 h 3.773 v -14.929 h -3.773 z m 4.419,0.646 h -5.065 v -16.222 h 5.065 z",
    fill: "#ffffff",
    id: "path282"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M 222.32105,125.20504 H 73.514046 v -3.587 H 222.32105 Z",
    fill: "#ffffff",
    id: "path284"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M 135.46905,117.83404 H 90.468046 v -8.306 h 45.001004 z",
    fill: "#d19e66",
    id: "path286"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "m 95.791046,117.83404 h -0.646 v -8.306 h 0.646 z",
    fill: "#ffffff",
    id: "path288"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "m 97.594046,117.83404 h -0.646 v -8.306 h 0.646 z",
    fill: "#ffffff",
    id: "path290"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "m 128.99005,117.83404 h -0.646 v -8.306 h 0.646 z",
    fill: "#ffffff",
    id: "path292"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "m 130.79205,117.83404 h -0.646 v -8.306 h 0.646 z",
    fill: "#ffffff",
    id: "path294"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "m 206.61005,121.61704 h -47.733 v -6.036 h 47.733 z",
    fill: "#d19e66",
    id: "path296"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M 140.79505,121.61704 H 86.840046 v -3.783 h 53.955004 z",
    fill: "#343a55",
    id: "path298"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M 141.95705,109.52804 H 87.769046 v -7.216 h 54.188004 z",
    fill: "#ffffff",
    id: "path300"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "m 90.110046,263.04904 c -9.068,-2.804 -28.554,1.652 -30.6652,6.432 -2.1125,4.779 14.1912,36.782 22.5252,38.427 8.334,1.646 31.979004,-3.596 32.116004,-8.224 -0.335,-10.827 -14.909004,-33.831 -23.976004,-36.635 z",
    fill: "#ffe815",
    id: "path302"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "m 84.082046,307.02404 -0.607,-0.222 c 1.169,-3.207 -3.153,-14.926 -9.248,-25.076 -4.719,-7.857 -9.157,-12.605 -12.175,-13.027 l 0.089,-0.64 c 4.562,0.637 10.358,9.538 12.64,13.336 5.602,9.328 10.676,21.852 9.301,25.629 z",
    fill: "#2c3451",
    id: "path304"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPisos);
export default __webpack_public_path__ + "static/media/pisos.82f73d470c15dd804f5206542eef4cb0.svg";
export { ForwardRef as ReactComponent };